import dataService from 'services/dataService';
import {
  apiAdminPanelAgencyDoctors,
  apiAgencyDoctorProfile,
  API_ADMIN_PANEL_AGENCY_DOCTORS,
  API_ADMIN_PANEL_AGENCIES,
  API_ROLES,
} from 'services/dataService/resources';

const ITEMS_PER_PAGE = 100;

const EMPTY_AGENCY_DOCTOR = {
  roles: [],
  agencies: [],
};

const INITIAL_STATE = {
  page: 1,
  itemsPerPage: ITEMS_PER_PAGE,
  filters: {
    agencyDoctorGuid: null,
    roleName: null,
    agencyGuid: null,
    status: null,
  },
  agencies: [],
  roles: [],
  agencyDoctor: EMPTY_AGENCY_DOCTOR,
  data: [],
  totalPages: 0,
  totalCount: 0,
};

const adminPanelAgencyDoctors = {
  state: INITIAL_STATE,
  reducers: {
    reset: () => INITIAL_STATE,
    setFilters: (state, payload) => ({
      ...state,
      filters: { ...state.filters, ...payload },
    }),
    setPage: (state, payload) => ({
      ...state,
      page: payload < 1 ? 1 : payload,
    }),
    setTotalCountAndTotalPages: (state, payload) => ({
      ...state,
      totalCount: payload.totalCount,
      totalPages: payload.totalPages,
    }),
    setAgencies: (state, payload) => ({
      ...state,
      agencies: payload,
    }),
    setAgencyDoctors: (state, payload) => ({
      ...state,
      data: payload,
    }),
    setAgencyDoctor: (state, payload) => ({
      ...state,
      agencyDoctor: payload,
    }),
    setRoles: (state, payload = []) => ({
      ...state,
      roles: payload,
    }),
  },
  effects: (dispatch) => ({
    async getRoles() {
      const { data } = await dataService.getList(
        `${API_ROLES}?userType=homeHealth`,
      );
      dispatch.adminPanelAgencyDoctors.setRoles(data);
    },
    async getAgencies() {
      const { error, data } = await dataService.getList(
        `${API_ADMIN_PANEL_AGENCIES}?noLimit=true`,
      );

      if (error) {
        throw error;
      }

      if (data && data.count > 0) {
        dispatch.adminPanelAgencyDoctors.setAgencies(data.items);
      }
    },
    async updateAgencyDoctorPage({ pageOffset }, state) {
      const { page, totalPages } = state.adminPanelAgencyDoctors;
      const newPage = page + pageOffset;
      dispatch.adminPanelAgencyDoctors.setPage(
        newPage <= totalPages ? newPage : totalPages,
      );

      return dispatch.adminPanelAgencyDoctors.getAgencyDoctors({
        page: newPage,
      });
    },
    async getAgencyDoctors({ items = ITEMS_PER_PAGE }, state) {
      const { filters, page } = state.adminPanelAgencyDoctors;
      const { data } = await dataService.getList(
        apiAdminPanelAgencyDoctors(items, page, filters),
      );
      if (data) {
        dispatch.adminPanelAgencyDoctors.setAgencyDoctors(data?.items || []);
        const totalCount = data?.count || 0;
        const totalPages = Math.ceil(totalCount / ITEMS_PER_PAGE);
        dispatch.adminPanelAgencyDoctors.setTotalCountAndTotalPages({
          totalCount,
          totalPages,
        });
      } else {
        dispatch.adminPanelAgencyDoctors.setAgencyDoctors([]);
        dispatch.adminPanelAgencyDoctors.setTotalCountAndTotalPages({
          totalCount: 0,
          totalPages: 0,
        });
      }
    },
    async getAgencyDoctor(agentGuid) {
      if (agentGuid) {
        const { error, data } = await dataService.getList(
          apiAgencyDoctorProfile(agentGuid),
        );
        if (error) throw error;
        if (data) {
          dispatch.adminPanelAgencyDoctors.setAgencyDoctor(data);
        }
      } else {
        dispatch.adminPanelAgencyDoctors.setAgencyDoctor(EMPTY_AGENCY_DOCTOR);
      }
    },
    async createAgencyDoctor(body) {
      const { error, data } = await dataService.createOne(
        API_ADMIN_PANEL_AGENCY_DOCTORS,
        body,
      );
      return { error, data };
    },
    async updateAgencyDoctor(body) {
      const { error, data } = await dataService.updateOnly(
        API_ADMIN_PANEL_AGENCY_DOCTORS,
        body,
      );
      return { error, data };
    },
  }),
};

export default adminPanelAgencyDoctors;
